import ActiveCircle from '../../utils/ActiveCircle'
import NotActiceCircle from '../../utils/NotActiceCircle'
import OwnerCircle from '../../utils/OwnerCircle'
// import Header from '../Header'
import ActiveApplications from './ActiveApplications'
import NotActiveApplications from './NotActiveApplications'
import OwnerAplications from './OwnerAplications'
import axios from 'axios'
import { useEffect, useState } from 'react'
import Empty from '../Empty'
import Loading from '../Loading'
// import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Header from '../Header'

const Applications = () => {
  const [backUrl, setBackUrl] = useState('')
  const [activeItems, setActiveItems] = useState([])
  const [expiredItems, setExpiredItems] = useState([])
  const [items, setItems] = useState([])
  const [age, setAge] = useState(null)
  const [modalItems, setModalItems] = useState(null)
  const [modal, setModal] = useState(true)

  const data = () => {
    axios.get(`${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/items?token=${JSON.parse(localStorage.getItem('token'))}`).then((res) => {
      setBackUrl(res.data.geri_buton_url)
      setActiveItems(res.data.active_items)
      setExpiredItems(res.data.expired_items)
      setItems(res.data.items)
      setModalItems(res.data.modal_items)
      setAge(res.data.yas)
    })
  }

  useEffect(() => {
    data()
  }, [])

  return (
    <>
      {!backUrl ? (
        <Loading text='Lütfen bekleyin...' />
      ) : (
        <div>
          {/* <div
            style={{
              backgroundColor: '#fff',
              position: 'sticky',
              top: 0,
              zIndex: 999,
            }}
          >
            <Header onClick={() => axios.get(backUrl)} />
          </div> */}
          <Header
            backButton={false}
            onClick={() => {
              // alert(window.ReactNativeWebView)
              if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
                window.ReactNativeWebView.postMessage('close')
              }
            }}
          />
          {activeItems?.length < 1 && items?.length < 1 && expiredItems?.length < 1 && (
            <>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Empty />
              </div>
            </>
          )}

          {activeItems?.length > 0 && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'start',
                marginTop: '1rem',
                marginLeft: '1rem',
              }}
            >
              <>
                <ActiveCircle />
                <h6>Aktif Başvurular</h6>
              </>
            </div>
          )}
          {activeItems?.map((item) => {
            console.log('activeItems: ', activeItems)
            return (
              <ActiveApplications
                key={item?.id}
                adi={item?.aktif_basvuru?.adi}
                son_basvuru_tarihi={item?.aktif_basvuru?.son_basvuru_tarihi}
                basvuru_sartlari_title={item?.aktif_basvuru?.basvuru_sartlari_title}
                basvuru_sartlari_aciklama={item?.aktif_basvuru?.basvuru_sartlari_aciklama}
                basvuru_turu={item?.aktif_basvuru?.basvuru_turu}
                basvuruId={item?.basvuru_id}
                basvuru_fotografi={item?.basvuru_fotografi}
                basvuru_fotograflari={item?.basvuru_fotograflari}
                basvuru_aciklamasi={item?.basvuru_aciklamasi}
                belge_aciklama={item?.belge_aciklama}
                ucret={item?.ucret}
                belge_sayisi={item?.belge_sayisi}
                yas_siniri={item?.yas_siniri}
                ikametgah_karatay_mi={item?.ikametgah_karatay_mi}
                basvuru_durum={item?.basvuru_durum}
                custom_inputs={item?.custom_inputs}
                route={item?.route}
                ownerItem={items}
                age={age}
              />
            )
          })}

          {items?.length > 0 && (
            <>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'start',
                  marginTop: '2rem',
                  marginLeft: '1rem',
                }}
              >
                <OwnerCircle />
                <h6>Başvurularım</h6>
              </div>
            </>
          )}
          {items?.map((item) => {
            return <OwnerAplications key={item?.id} basvuruTarihi={item?.basvuru?.basvuru_tarihi} adi={item?.basvuru.item?.adi} durum={item?.basvuru.durum.adi} renk={item?.basvuru.durum.renk} itemId={item?.id} durumId={item?.basvuru.durum.id} aciklama={item?.aciklama} />
          })}
          {expiredItems?.length > 0 && (
            <>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'start',
                  marginTop: '2rem',
                  marginLeft: '1rem',
                }}
              >
                <NotActiceCircle />
                <h6>Süresi Geçen Başvurular</h6>
              </div>
            </>
          )}
          {expiredItems?.map((item, index) => {
            return index <= 4 && <NotActiveApplications key={item?.id} adi={item?.gecmis_basvuru.adi} id={item?.basvuru_id} getData={data} />
          })}
        </div>
      )}
      {modalItems && (
        <Modal
          size={32}
          aria-labelledby='contained-modal-title-vcenter'
          centered
          show={modal}
          onHide={() => {
            setModal(false)
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title id='contained-modal-title-vcenter' style={{ fontWeight: '400' }}>
              {modalItems.title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <img src={'https://app.yanibasimdakaratay.com/uploads/dijital_basvurular_modals/' + modalItems?.url} alt='' style={{ borderRadius: '10px', marginBottom: '15px' }} width={'100%'} />
            {modalItems?.desc && <p>{modalItems.desc}</p>}
          </Modal.Body>
        </Modal>
      )}
    </>
  )
}

export default Applications
